import Vuex from 'vuex'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import createPersistedState from 'vuex-persistedstate'

Vue.use(VueCookie)

const state = {
  access_token: '',
  active: false,
  cities: [],
  domain: process.env.EVENTDB_API_HOST,
  divisionSF: '',
  establishments: [],
  list_filter: JSON.parse(VueCookie.get('filter')) || { city: '', school: '', type: '' },
  recordTypeId: process.env.NODE_ENV !== 'production' ? '0121p000000BHqJ' : '0121p000000BHqJ',
  role: '',
  schools: [],
  schoolSF: '',
  theme: VueCookie.get('theme') || 'light',
  ttl: 43200,
  typeSF: '',
  userId: ''
}

const getters = {
  access_token: state => state.access_token,
  active: state => state.active,
  cities: state => state.cities,
  domain: state => state.domain,
  divisionSF: state => state.divisionSF,
  establishments: state => state.establishments,
  list_filter: state => state.list_filter,
  schools: state => state.schools,
  isAuthenticated: state => !!state.access_token && state.active,
  recordTypeId: state => state.recordTypeId,
  role: state => state.role,
  schoolSF: state => state.schoolSF,
  theme: state => state.theme,
  ttl: state => state.ttl,
  typeSF: state => state.typeSF,
  userId: state => state.userId
}

const mutations = {
  ADD_ACCESSTOKEN: (state, value) => {
    state.access_token = value
  },
  ADD_ACTIVE: (state, value) => {
    state.active = value
  },
  ADD_CITY: (state, value) => {
    state.cities = value
  },
  ADD_DOMAIN: (state, value) => {
    state.domain = value
  },
  ADD_ESTABLISHMENT: (state, value) => {
    state.establishments = value
  },
  ADD_FILTER: (state, value) => {
    state.list_filter = value
    VueCookie.set('filter', JSON.stringify(value))
  },
  ADD_RECORDTYPEID: (state, value) => {
    // Définir le record type de telle école
    state.recordTypeId = value
  },
  ADD_ROLE: (state, value) => {
    state.role = value
  },
  ADD_SCHOOL: (state, value) => {
    state.schools = value
  },
  ADD_THEME: (state, value) => {
    VueCookie.set('theme', value)
    state.theme = value
  },
  ADD_USERID: (state, value) => {
    state.userId = value
  },
  ADD_TYPESF: (state, value) => {
    let type = ''
    switch (value) {
      // Bidouille e-artsup JDMI
      case 'eartdecouverte':
        type = 'Journée d\'immersion'
        break
      case '6374b9a4276f97549c7d94ee':
        type = 'After school'
        break
      case '6385cb76276f97549c7d967a':
      case '6385e34facecaf218ff15fb5': // Id dev
        type = 'Atelier'
        break
      case '5ba8a09b1b1a92ca1db3f640':
        type = 'Conférence'
        break
      case '5b9fcacdc2e4315bd836890d':
      case '5ba8a0f81b1a92ca1db3f647':
        type = 'JPO'
        break
      case '5ba8a2191b1a92ca1db3f660':
        type = 'Journée de sélection'
        break
      case '5ba8a2381b1a92ca1db3f662':
      case '5dd3ac53a413380bd3698710':
        type = 'JDMI'
        break
      // case '5ba8a26d1b1a92ca1db3f668':
      //   type = 'JPC'
      //   break
      case '5e8347fdcd932cdd6ab96c28':
        type = 'Biotech Day'
        break
      case '6711014e5c90a437e9a23bc7':
        type = 'Bachelor Day'
        break
      case '6716757dd2d123482d749246':
        type = 'Autre'
        break
      case '5e96e2e3c6b12aa35faa2e6b':
        type = 'Webinar'
        break
      case '5ed7b339005ea323f668e4a3':
        type = 'JPO Hybride'
        break
      case '6012b7b503ec68c4e6899166':
        type = 'Maker Session'
        break
      case '6347c35b276f97549c7d9160':
        type = 'Rdv orientation'
        break
      case '642c2c6054fd704e5af5b03b':
        type = 'Soirée Spéciale'
        break
      case '6332b02b276f97549c7d8d80':
        type = 'Time Travel'
        break
      case '5bd0237d08695f9cd07a0092':
        type = 'Journée d\'immersion'
        break
    }
    state.typeSF = type
  },
  ADD_SCHOOLSF: (state, value) => {
    let school = ''
    switch (value) {
      case '5b9bcabf90c8a831489aefca':
        school = 'ISEG MCS'
        break
      case '5ba89e261b1a92ca1db3f622':
        school = 'ISG'
        break
      case 'ESME':
        school = 'ESME'
        break
      // case '5b9bcb4690c8a831489aefd1':
      //   school = 'ESME'
      //   break
      case '5b9bcb4f90c8a831489aefd3':
        school = 'Sup\'Biotech'
        break
      case '5b9bcaa390c8a831489aefc8':
      case '5ba89e721b1a92ca1db3f624':
      case '5ba89e4f1b1a92ca1db3f623':
      case '5b9bcab590c8a831489aefc9':
      case '63e11f451ea7572069151a14':
      case '63e120881ea7572069151a50':
      case '63e1218c1ea7572069151a7b':
      case '63e1225e1ea7572069151aa5':
      case '63e123211ea7572069151ad0':
      case '63e0dee71ea75720691518ec':
      case '63e1257d1ea7572069151aee':
      case '63e125f21ea7572069151af1':
        school = 'ISG'
        break
      case '5b9bcb7a90c8a831489aefd8':
        school = 'SUPInternet'
        break
      case '5b9bcb7090c8a831489aefd7':
        school = 'IONIS STM'
        break
      case '5b9bcb6990c8a831489aefd6':
        school = 'e-artsup'
        break
      case '5b9bcb3990c8a831489aefd0':
        school = 'EPITA'
        break
      case '612f8af0bd78db2d711ddba4':
        school = 'EPITA IA Institut'
        break
      case '5b9bcb4a90c8a831489aefd2':
        school = 'IPSA'
        break
      case '5b9bcacd90c8a831489aefcb':
        school = 'Moda Domani'
        break
      case '5c93983869cf3289a90efc23':
        school = 'XP'
        break
      case '6140a1f4bd78db2d711ddebb':
        school = 'SUPINFO'
        break
      case '5d96008feaa7db53c25b8dd3':
        school = 'Epitech Digital'
        break
    }
    state.schoolSF = school
  },
  ADD_DIVISIONSF: (state, value) => {
    let school = ''
    switch (value) {
      case '5b9bcabf90c8a831489aefca':
        school = 'ISEG MCS'
        break
      case '5ba89e261b1a92ca1db3f622':
        school = 'ISG PBM'
        break
      case '5b9bcb4690c8a831489aefd1':
        school = 'ESME'
        break
      case '5b9bcb4f90c8a831489aefd3':
        school = 'Sup\'Biotech'
        break
      case '5b9bcaa390c8a831489aefc8':
        school = 'ISG BS France'
        break
      case '5ba89e721b1a92ca1db3f624':
      case '61b1d7883ce2d2329d089f1c':
        school = 'ISG BS International'
        break
      case '63e11f451ea7572069151a14':
      case '63e120881ea7572069151a50':
      case '63e1218c1ea7572069151a7b':
      case '63e1225e1ea7572069151aa5':
      case '63e123211ea7572069151ad0':
      case '63e0dee71ea75720691518ec':
      case '63e1257d1ea7572069151aee':
      case '63e125f21ea7572069151af1':
        school = 'ISG France'
        break
      case '5ba89e4f1b1a92ca1db3f623':
        school = 'ISG MSC et MBA'
        break
      case '5b9bcb7a90c8a831489aefd8':
        school = 'SUPInternet'
        break
      case '5b9bcb7090c8a831489aefd7':
        school = 'IONIS STM'
        break
      case '5b9bcb6990c8a831489aefd6':
        school = 'e-artsup'
        break
      case '5b9bcb3990c8a831489aefd0':
        school = 'EPITA'
        break
      case '612f8af0bd78db2d711ddba4':
        school = 'EPITA IA Institut'
        break
      case '5b9bcb4a90c8a831489aefd2':
        school = 'IPSA'
        break
      case '5b9bcacd90c8a831489aefcb':
        school = 'Moda Domani'
        break
      case '5b9bcab590c8a831489aefc9':
        school = 'ISG Luxury'
        break
      case '5c93983869cf3289a90efc23':
        school = 'XP'
        break
      case '6140a1f4bd78db2d711ddebb':
        school = 'SUPINFO'
        break
      case '5d96008feaa7db53c25b8dd3':
        school = 'Epitech Digital'
        break
    }
    state.divisionSF = school
  }
}

const actions = {
  addAccessToken: (store, obj) => {
    store.commit('ADD_ACCESSTOKEN', obj)
  },
  addActive: (store, obj) => {
    store.commit('ADD_ACTIVE', obj)
  },
  addCity: (store, obj) => {
    store.commit('ADD_CITY', obj)
  },
  addDomain: (store, obj) => {
    store.commit('ADD_DOMAIN', obj)
  },
  addEstablishment: (store, obj) => {
    store.commit('ADD_ESTABLISHMENT', obj)
  },
  addFilter: (store, obj) => {
    store.commit('ADD_FILTER', obj)
  },
  addRecordTypeId: (store, obj) => {
    store.commit('ADD_RECORDTYPEID', obj)
  },
  addRole: (store, obj) => {
    store.commit('ADD_ROLE', obj)
  },
  addSchool: (store, obj) => {
    store.commit('ADD_SCHOOL', obj)
  },
  addTheme: (store, obj) => {
    store.commit('ADD_THEME', obj)
  },
  addUserId: (store, obj) => {
    store.commit('ADD_USERID', obj)
  },
  addTypeSF: (store, obj) => {
    store.commit('ADD_TYPESF', obj)
  },
  addSchoolSF: (store, obj) => {
    store.commit('ADD_SCHOOLSF', obj)
  },
  addDivisionSF: (store, obj) => {
    store.commit('ADD_DIVISIONSF', obj)
  }
}

let store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      key: 'eventDB',
      paths: ['access_token', 'active', 'cities', 'establishments', 'role', 'schools', 'userId']
    })
  ]
})

global.store = store

export default store



// WEBPACK FOOTER //
// ./src/components/Store.js